export function GetwayForm(token) {
  // If the response contains a token, submit a form with the token
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = 'https://sep.shaparak.ir/MobilePG/MobilePayment';

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'token';
  tokenInput.value = token;

  form.appendChild(tokenInput);
  document.body.appendChild(form);

  form.submit();
}
